import { render } from "./NewForm.vue?vue&type=template&id=6761bd52"
import script from "./NewForm.vue?vue&type=script&lang=js"
export * from "./NewForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__